<div [formGroup]="measuringPointsForm">
    <div class="d-none d-lg-block">
        <div class="row gx-0 px-1 py-2 mb-3 table-header fw-bold">
            <div class="col-2" translate="CONFIRMATION_MEASURING_POINTS_ID_LABEL"></div>
            <div class="col-3" translate="CONFIRMATION_MEASURING_POINTS_DESCRIPTION_LABEL"></div>
            <div class="col-2" translate="CONFIRMATION_MEASURING_POINTS_OLD_VALUE_LABEL"></div>
            <div class="col-5" translate="CONFIRMATION_MEASURING_POINTS_NEW_VALUE_LABEL"></div>
        </div>
    </div>
    @for (point of model.points.value; track point.measuringPointID.value) {
        <div class="row mb-3 gx-0 px-1">
            <!-- ID -->
            <div class="row gx-0 col-lg-2">
                <label
                    class="col-3 col-form-label text-start d-lg-none"
                    translate="CONFIRMATION_MEASURING_POINTS_ID_LABEL"
                ></label>
                <span class="col col-form-label fw-semibold text-start">{{ point.measuringPointID.value }}</span>
            </div>
            <!-- Description -->
            <div class="row gx-0 col-lg-2">
                <label
                    class="col-3 col-form-label text-start d-lg-none"
                    translate="CONFIRMATION_MEASURING_POINTS_DESCRIPTION_LABEL"
                ></label>
                <span class="col col-form-label fw-semibold text-start">{{ point.measuringPointDesc.value }}</span>
            </div>
            <!-- Old Value -->
            <div class="row gx-0 col-lg-2">
                <label
                    class="col-3 col-form-label text-start d-lg-none"
                    translate="CONFIRMATION_MEASURING_POINTS_OLD_VALUE_LABEL"
                ></label>
                <span class="col col-form-label fw-normal text-start">{{ point.oldValue }}</span>
            </div>
            <!-- New Value -->
            <div class="row gx-0 col-lg-5">
                <label
                    class="col-3 col-form-label text-start d-lg-none"
                    translate="CONFIRMATION_MEASURING_POINTS_NEW_VALUE_LABEL"
                ></label>
                <div class="col">
                    <pace-core-number-input
                        [(model)]="point.newValue"
                        [parentForm]="measuringPointsChildren"
                        [ariaLabel]="'CONFIRMATION_MEASURING_POINTS_NEW_VALUE_LABEL' | translate"
                    ></pace-core-number-input>
                </div>
                @if (!(point.isMandatory === '1')) {
                    <div class="col-3 ps-1">
                        <pace-core-checkbox-input
                            id="notAvailable"
                            [(model)]="point.isNotAvailable"
                            [parentForm]="measuringPointsChildren"
                            (valueChange)="newValueSetRequired(point)"
                        ></pace-core-checkbox-input>
                    </div>
                }
            </div>
            <hr />
        </div>
    }
</div>
